import { render, staticRenderFns } from "./IFrameLoaderFiltered.vue?vue&type=template&id=53bd8128&scoped=true"
import script from "./IFrameLoaderFiltered.vue?vue&type=script&lang=ts"
export * from "./IFrameLoaderFiltered.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bd8128",
  null
  
)

export default component.exports